module.exports = __webpack_public_path__ + "static/media/29ADMSPC17.6f87ae6b.jpg";